import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { useSelector } from "react-redux";
import { Button, Grid, Typography , Menu , MenuItem , TextField , Box } from "@mui/material";
import {ListAlt ,SignalCellularAlt , AirportShuttle} from "@mui/icons-material";
import { DataGrid  } from "@mui/x-data-grid";
import "jspdf-autotable";
import io from "socket.io-client";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useFormik, useField } from "formik";
import * as yup from "yup";
import _ from "lodash";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from 'moment-timezone';
import { CUSTOM_CONSTANTS } from "Constants";
//Services
import TriplistApi from "Services/Triplist";
import Passengerhistorydetails from "Pages/Modals/Passengerhistory/Moredetails";

const Passenger = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [row, setRow] = useState([]);
  const timezone = useSelector((state) => state.timezone.timezone);
  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openaction = Boolean(anchorEl);
  const Tripstatus = ["CANCELLED", "COMPLETED", "SCHEDULED"];
  const Paymentmethod = ["CORPORATE"];
  const [servicesData, setServicesData] = useState([]);
  const [filtervalues , setFiltervalues] = useState({});
  const [moredetailsmodel, setmoredetailsModal] = useState(false);
  const [requestId, setrequestId] = useState("");
  const [metrics,setmetrics] = useState({});
  const  corporateId = useSelector(
    (state) => state?.ProfileSettingsReducer?.profiledetails?._id
  );  
 // console.log('localStorage.getItem-->',`Bearer ${localStorage.getItem("token")}`);
 
  // Get Passenger list api

  const gettriplists = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
   // console.log('filtervalues-->',filtervalues);
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
       // console.log('Overall--->',res?.data);
        setRow(res?.data?.data?.data.triplists);
        setmetrics({
          totalRidesCount: res?.data?.data.totalRidesCount,
          cancelledRides: res?.data?.data.cancelledRides,
          totalRevenue: res?.data?.data.totalRevenue,
        });

      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    TriplistApi.getoverallstatement_corp_monthly({ page, limit: pageSize , filtervalues , corporateId })
      .then(onSuccess, onFailure);
  }, [page, pageSize, filtervalues]);

  useEffect(() => {
    gettriplists();
  }, [gettriplists]);


  const handlePageChange = (newPage) => {
   // console.log('newPage-->',newPage);
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  function formatDate(inputDate) {
    if (!inputDate) {
      return "--"; // Return '--' if inputDate is null or undefined
    }
    
  return moment(inputDate).tz(timezone).format("YYYY-MM-DD hh:mm A");

  }

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

  const handleview = (event, rowData) => {
   // console.log('rowData-->',rowData)
    setrequestId(rowData?._id);
    setmoredetailsModal(true);
  };
 
  const handleClosemoredetailsModal = () => {
    setmoredetailsModal(false);
    gettriplists();
  };

  const dataRows = _.map(row || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    pickuplocation: data?.pickupAddress,
    stop1address:data?.stop1_address,
    stop2address:data?.stop2_address,
    bookingId: data?.bookingId,
    droplocation: data?.dropAddress,
    requestedAt: formatDate(data?.requestedAt),
    status:data?.tripStatus,
    Paymentmode:data?.paymentMode,
    Total:data?.estimatedFare.toFixed(2),
    commission:data?.earnedCommission,
    driverearned:data?.driverEarnings && data?.tripStatus=="COMPLETED" ? (data?.driverEarnings?.earnings ?? 0).toFixed(2):0,
    statusbackground:data?.tripStatus ? 
    data?.tripStatus == "COMPLETED" ? "#00c292" : 
    data?.tripStatus == "CANCELLED" ? "#f8312fd6" : "#2d7ea8"
    : "#2d7ea8",
    row: data,
  }));

  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex: 1,
      minWidth: 60, 
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "bookingId",
      headerName: "Booking ID",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.bookingId}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "pickuplocation",
      headerName: "Picked up",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.pickuplocation}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "stop1address",
      headerName: "Stop 1",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.stop1address || "--"}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "stop2address",
      headerName: "Stop 2",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.stop2address || "--"}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "droplocation",
      headerName: "Drop location",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.droplocation}</Typography>
            </div>
          </>
        );
      },
    },
    {
    field: "actions",
    headerName: "Request Details",
    minWidth: 150, // Minimum column width
    resizable: true, // Allow users to resize
    sortable: false,
    disableColumnMenu: true,
    renderCell: (params) => {
      const rowData = params?.row?.row;
      return (
        <>
    <div className={classes.iconsWrapper}>
    <Button
      id="basic-button"
      aria-controls={openaction ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={openaction ? 'true' : undefined}
      onClick={(e) => handleview(e, rowData)}
    >
      View
    </Button>
        </div>
        </>
      );
    },
    }, 
    {
      field: "requestedAt",
      headerName: "Dated on",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.requestedAt}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography className={classes.status} 
              sx={{ background: params?.row?.statusbackground }}
              variant="body2">{params?.row?.status}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "Paymentmode",
      headerName: "Payment Mode",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.Paymentmode}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "Total",
      headerName: "Total",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{CUSTOM_CONSTANTS.BASE_CURRENCY} {params?.row?.Total}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "commission",
      headerName: "Commission",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{CUSTOM_CONSTANTS.BASE_CURRENCY} {params?.row?.commission}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "driverearned",
      headerName: "Earned by driver",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{CUSTOM_CONSTANTS.BASE_CURRENCY} {params?.row?.driverearned}</Typography>
            </div>
          </>
        );
      },
    },
  ];

  // handle dates

const handlefromdate = (newValue) => {
  if (newValue === null || newValue === "") {
    formik.setFieldValue("fromdate", newValue);
  } else {
    const selectedDate =
      newValue instanceof Date ? newValue : new Date(newValue);
    const parsedDate = moment(selectedDate);
    const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
    formik.setFieldValue("fromdate", formattedDate);
  }
};

const handletodate = (newValue) => {
  if (newValue === null || newValue === "") {
    formik.setFieldValue("todate", newValue);
  } else {
    const selectedDate =
      newValue instanceof Date ? newValue : new Date(newValue);
    const parsedDate = moment(selectedDate);
    const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
    formik.setFieldValue("todate", formattedDate);
  }
};

  // filter form 

  function convertToISO(inputDate) {
    if (!inputDate) {
      return "--"; // Handle null or undefined input
    }
  
    // Parse the input date string
    const date = new Date(inputDate);
  
    if (isNaN(date.getTime())) {
      return "--"; // Handle invalid date formats
    }
  
    // Convert to ISO string and replace "Z" with "+00:00" for UTC offset
    const isoString = date.toISOString().replace("Z", "+00:00");
    return isoString;
  }
  

const handlefiltertriplist = (formValues) => {
   
  formValues.fromdate = convertToISO(formValues.fromdate);
  formValues.todate = convertToISO(formValues.todate);
 // console.log('formValues-->',formValues);
 // dispatch(showLoader("Loading please wait..."));
  setFiltervalues(formValues);
  };

  const formik = useFormik({
    initialValues: {
      tripStatus: "",
      paymentMode: "",
      fromdate: "",
      todate: "",
    },
    validationSchema: yup.object({
      fromdate: yup.string().required("Status is required").nullable(),
      todate: yup.string().required("Service is required").nullable(),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      handlefiltertriplist(values); // Ensure this processes `values` correctly
    },
  });
  
  return (  
    <>

<div className={classes.pages}>
<Grid container className={classes.root}>

<Grid container className={classes.metricboxes}>

<Grid item xs={4} className={classes.metricbox} >
<Box sx={{ background: '#fb9678' }}>
<Typography variant="h2">{metrics.totalRidesCount}</Typography>
<Typography variant="body2">TOTAL NO OF RIDES</Typography>
<ListAlt/>
</Box>
</Grid>
<Grid item xs={4} className={classes.metricbox} >
<Box sx={{ background: '#00c292' }}>
<Typography variant="h2">{CUSTOM_CONSTANTS.BASE_CURRENCY} {metrics.totalRevenue}</Typography>
<Typography variant="body2">REVENUE</Typography>
<SignalCellularAlt/>
</Box>
</Grid>
<Grid item xs={4} className={classes.metricbox} >
<Box sx={{ background: '#ab8ce4' }}>
<Typography variant="h2">{metrics.cancelledRides}</Typography>
<Typography variant="body2">CANCELLED RIDES</Typography>
<AirportShuttle/>
</Box>
</Grid>

</Grid>

<Grid container className={classes.utilities}>

<Grid item xs={2} md={2} lg={2} xl={2} className={classes.filters}>
<TextField
  name="tripStatus"
  id="tripStatus"
  select
  label="All status"
  value={formik?.values?.tripStatus || ""}
  onChange={formik?.handleChange}
  error={
    formik?.errors?.tripStatus &&
    formik?.touched?.tripStatus
  }
  helperText={
    formik?.errors?.tripStatus &&
    formik?.touched?.tripStatus &&
    formik?.errors?.tripStatus
  }
  fullWidth
  variant="outlined"
  size="small"
>
<MenuItem key="All status" value="">
    All Status
  </MenuItem> 
{Tripstatus.map((status) => (
  <MenuItem key={status} value={status}>
    {status}
  </MenuItem>
))}
</TextField>
</Grid>
<Grid item xs={2} md={2} lg={2} xl={2} className={classes.filters}>
<TextField
  name="paymentMode"
  id="paymentMode"
  select
  label="All Payment"
  value={formik?.values?.paymentMode || ""}
  onChange={formik?.handleChange}
  error={
    formik?.errors?.paymentMode &&
    formik?.touched?.paymentMode
  }
  helperText={
    formik?.errors?.paymentMode &&
    formik?.touched?.paymentMode &&
    formik?.errors?.paymentMode
  }
  fullWidth
  variant="outlined"
  size="small"
>
<MenuItem key="All payment" value="">
    All Payment
  </MenuItem>
{Paymentmethod.map((booking) => (
  <MenuItem key={booking} value={booking}>
    {booking}
  </MenuItem>
))}
</TextField>
</Grid>
<Grid item xs={3} md={3} lg={3} xl={3} className={classes.filters}>
  <div className={classes.datePickerStyle}>
  <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
  label="From Date"
  value={formik?.values?.fromdate || ""}
  size="small"
  onChange={(newValue) => {
  handlefromdate(newValue);
  }}
  renderInput={(params) => (
  <TextField
    {...params}
    error={
      formik?.errors?.fromdate &&
      formik?.touched?.fromdate
    }
    helperText={
      formik?.errors?.fromdate &&
      formik?.touched?.fromdate &&
      formik?.errors?.fromdate
    }
  />
  )}
  />
  </LocalizationProvider>
  </div>
</Grid>
<Grid item xs={3} md={3} lg={3} xl={3} className={classes.filters}>
<div className={classes.datePickerStyle}>
  <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
  label="To Date"
  value={formik?.values?.todate || ""}
  size="small"
  onChange={(newValue) => {
  handletodate(newValue);
  }}
  renderInput={(params) => (
  <TextField
    {...params}
    error={
      formik?.errors?.todate &&
      formik?.touched?.todate
    }
    helperText={
      formik?.errors?.todate &&
      formik?.touched?.todate &&
      formik?.errors?.todate
    }
  />
  )}
  />
  </LocalizationProvider>
  </div>
</Grid>
<Grid item xs={2} md={2} lg={2} xl={2} className={classes.Endbtn}>
    <Button variant="contained" onClick={formik?.handleSubmit}>
      Filter
    </Button>
</Grid>

</Grid>

<Grid item xs={12}>
    <section className={classes.dataGridTable}>
      <DataGrid
       className={classes.tripgridtable}
        getRowId={(row) => row?.row?._id}
        rows={dataRows}
        columns={columns}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => {
         // console.log("newPageSize--->",newPageSize);
          setPageSize(newPageSize);
          setPage(1);
        }}
        onPageChange={(newPage) => handlePageChange(newPage)}
        rowsPerPageOptions={[5, 10, 25, 50]}
        pagination
        autoHeight={true}
        disableSelectionOnClick
        scrollbarSize={4}
        rowHeight={100}
        style={{ padding: "10px", borderRadius: "0px" }}
        paginationMode="server"
        rowCount={totalPages}
      />
    </section>
</Grid>

</Grid>
<Passengerhistorydetails
        openDialog={moredetailsmodel}
        id={requestId}
        handleClose={handleClosemoredetailsModal}
></Passengerhistorydetails>
</div>

    </>
  );
};

export default Passenger;
